import React from 'react'
import { BigNumber } from 'ethers'
import ReactTooltip from 'react-tooltip'
import { getReadableNumber } from 'src/helpers/getReadableNumber'

interface IProps {
  apys: BigNumber[]
  isRewardPeriodFinished: boolean
}

export function CombinedAPY({ apys, isRewardPeriodFinished }: IProps) {
  const sum = apys?.reduce((prev, cur) => prev.add(cur), BigNumber.from(0))

  return (
    <>
      <ReactTooltip id="combined-api" disable={isRewardPeriodFinished} />
      <span
        data-for="combined-api"
        data-place="top"
        data-tip={apys?.map((apy) => getReadableNumber(apy.mul(100)) + ' %').join('+')}
        data-effect="solid"
        className="combined-api"
      >
        <div>{isRewardPeriodFinished ? '0' : getReadableNumber(sum?.mul(100))} %</div>
      </span>
    </>
  )
}
